import { useState } from 'react';

const useSelectedValuesTariffColumn = (tariffValues) => {
  const [selectedTariffValues, setSelectedTariffValues] = useState({});

  const handleSelectChangeTariffColumn = (field, value) => {
    setSelectedTariffValues((prev) => {
      const updated = { ...prev };

      if (!value) {
        delete updated[field];
      } else {
        updated[field] = value;
      }

      return updated;
    });
  };

  const getOptionsTariffColumnForSelect = (field) => {
    const selected = Object.entries(selectedTariffValues)
      .filter(([key]) => key !== field)
      .map(([_, val]) => val);

    return tariffValues.filter((opt) => !selected.includes(opt.value));
  };

  return { handleSelectChangeTariffColumn, getOptionsTariffColumnForSelect };
};

export default useSelectedValuesTariffColumn;
